module.exports = __webpack_public_path__ + "static/media/Florida Forestry Association Logo.0daa0da5.png";